import { Grid } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/styles";
import React from "react";
import { useIntl } from "react-intl";
import { ActionMeta, ValueType } from "react-select/src/types";
import { CourseType, CourseTypeEnumValues, CourseTypeGroupTranslationKey } from "../../model/Course";
import { GetTranslation } from "../../translations/GetTranslation";
import FormGridCell from "../common/FormGridCell";
import CustomSelect, { OptionType } from "../common/customSelect/CustomSelect";
import TranslatedMessage from "../translations/TranslatedMessage";

type CourseTypeSelectProps = {
  selectedCourseTypes: CourseType[];
  onCourseTypeSelectChange: (selectedElements: ValueType<OptionType>, actionMeta?: ActionMeta<OptionType>) => void;
  mandatory?: boolean;
  error?: boolean;
};

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      paddingTop: "15px",
      paddingBottom: "15px",
      width: "100%",
      zIndex: 100000000,
    },
  })
);

const CourseTypeSelect: React.FunctionComponent<CourseTypeSelectProps> = ({
  selectedCourseTypes,
  onCourseTypeSelectChange,
  mandatory = false,
  error,
}) => {
  const cssClasses = useStyles({});
  const intl = useIntl();

  const courseTypesWithTranslation = CourseTypeEnumValues.map((courseType) => ({
    value: courseType,
    translation: GetTranslation(intl, CourseTypeGroupTranslationKey[courseType]),
  }));

  const getCourseTypesWithTranslations = (courseTypes: CourseType[]) =>
    courseTypesWithTranslation
      .filter((ct) => courseTypes.includes(ct.value))
      .sort((a, b) => a.translation.localeCompare(b.translation))
      .map((courseType) => ({
        value: courseType.value,
        label: <span>{courseType.translation}</span>,
      }));

  return (
    <Grid container={true}>
      <FormGridCell size={"wide"}>
        <CustomSelect
          className={cssClasses.root}
          required={false}
          value={getCourseTypesWithTranslations(selectedCourseTypes)}
          name="courseType-select-create"
          label=""
          placeholder={
            <>
              <TranslatedMessage id="expert.field.courseType.placeholder" />
              {mandatory ? "*" : ""}
            </>
          }
          options={getCourseTypesWithTranslations(CourseTypeEnumValues)}
          isMulti={true}
          onChange={onCourseTypeSelectChange}
          menuPlacement={"auto"}
          isClearable={false}
          useDocumentBodyAsPortalTarget={true}
          error={error}
        />
      </FormGridCell>
    </Grid>
  );
};

export default CourseTypeSelect;
